export const defaultWirelessCoverageInfo = {
  totalClient: null,
  status: '-',
  meanRSSI: null,
  weakPercent: null,
  threshold: null,
  series: [],
};